<div class="not-found-block">
  <h1 class="mat-text-on-surface">404</h1>
  <h1>Oops, the page you're looking for does not exist.</h1>
  <hr>
  <p>You may want to head back to the homepage.</p>
  <!-- routerlink can bypass our redirect guard, so we use a button with a href -->
  <a mat-button mat-stroked-button  href="/">Go to Homepage</a>
</div>